import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { combiner, featureKey } from './combiner';

import { FinancialEntityBranchesEffects } from './financialEntityBranches/effects';
import { FinancialEntityBranchesService } from './financialEntityBranches/service';
import { FinancialEntityBranchEffects } from './financialEntityBranch/effects';
import { FinancialEntityBranchService } from './financialEntityBranch/service';
import { InformativeMessagesEffects } from './informativeMessages/effects';
import { InformativeMessagesService } from './informativeMessages/service';
import { ValidateZipCodeEffects } from './validateZipCode/effects';
import { ValidateZipCodeService } from './validateZipCode/service';
import { ValidateVertiRelationsEffects } from './validateVertiRelations/effects';
import { ValidateVertiRelationsService } from './validateVertiRelations/service';
import { ValidatePartnershipCardEffects } from './validatePartnershipCard/effects';
import { ValidatePartnershipCardService } from './validatePartnershipCard/service';
import { PartnershipValidationStepEffects } from './partnershipValidationStep/effects';
import { PartnershipValidationStepService } from './partnershipValidationStep/service';
import { ValidateFiscalCodeEffects } from './validateFiscalCode/effects';
import { ValidateFiscalCodeService } from './validateFiscalCode/service';
import { PostUserEffects } from './postUser/effects';
import { PostUserService } from './postUser/service';
import { UsersIdEffects } from './usersId/effects';
import { UsersIdService } from './usersId/service';
import { GetUserByIdEffects } from './getUserById/effects';
import { GetUserByIdService } from './getUserById/service';
import { ParticipantsEffects } from './participants/effects';
import { ParticipantsService } from './participants/service';
import { PoliciesEffects } from './policies/effects';
import { PoliciesService } from './policies/service';

@NgModule({
  imports: [
    EffectsModule.forFeature([
      FinancialEntityBranchesEffects,
      FinancialEntityBranchEffects,
      InformativeMessagesEffects,
      ValidateZipCodeEffects,
      ValidateVertiRelationsEffects,
      ValidatePartnershipCardEffects,
      PartnershipValidationStepEffects,
      ValidateFiscalCodeEffects,
      PostUserEffects,
      UsersIdEffects,
      GetUserByIdEffects,
      ParticipantsEffects,
      PoliciesEffects,
    ]),
    StoreModule.forFeature(featureKey, combiner),
  ],
  providers: [
    FinancialEntityBranchesService,
    FinancialEntityBranchService,
    InformativeMessagesService,
    ValidateZipCodeService,
    ValidateVertiRelationsService,
    ValidatePartnershipCardService,
    PartnershipValidationStepService,
    ValidateFiscalCodeService,
    PostUserService,
    UsersIdService,
    GetUserByIdService,
    ParticipantsService,
    PoliciesService,
  ],
})
export class ApplicationUtilitiesStoreModule {}
